"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThemeGlobalStyles = exports.ThemeCSSVariableProvider = exports.ThemeProvider = exports.ThemeType = void 0;
var tslib_1 = require("tslib");
var react_provision_1 = require("@newfront-insurance/react-provision");
var react_1 = (0, tslib_1.__importDefault)(require("react"));
var react_use_1 = require("react-use");
var styled_components_1 = require("styled-components");
var css_variables_1 = require("../theme/css-variables");
var theme_dark_1 = require("../theme/theme-dark");
var theme_light_1 = require("../theme/theme-light");
var ThemeType;
(function (ThemeType) {
    ThemeType["LIGHT"] = "light";
    ThemeType["DARK"] = "dark";
    ThemeType["SYSTEM"] = "system";
})(ThemeType = exports.ThemeType || (exports.ThemeType = {}));
exports.ThemeProvider = (0, react_provision_1.createProvider)(function () {
    var prefersDarkMode = (0, react_use_1.useMedia)('(prefers-color-scheme: dark)');
    var _a = (0, react_use_1.useLocalStorage)('dash.theme', ThemeType.LIGHT), currentTheme = _a[0], setTheme = _a[1];
    var theme = getTheme(currentTheme, prefersDarkMode);
    return {
        name: currentTheme,
        setTheme: function (type) { return setTheme(type); },
        theme: theme,
    };
});
function getTheme(currentTheme, prefersDarkMode) {
    if (currentTheme === ThemeType.SYSTEM) {
        return prefersDarkMode ? theme_dark_1.darkTheme : theme_light_1.lightTheme;
    }
    if (currentTheme === ThemeType.DARK) {
        return theme_dark_1.darkTheme;
    }
    return theme_light_1.lightTheme;
}
function ThemeCSSVariableProvider(props) {
    var children = props.children;
    var theme = (0, react_provision_1.useProvider)(exports.ThemeProvider).theme;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(BodyVariables, { customTheme: theme }),
        children));
}
exports.ThemeCSSVariableProvider = ThemeCSSVariableProvider;
function ThemeGlobalStyles(props) {
    var children = props.children;
    var theme = (0, react_provision_1.useProvider)(exports.ThemeProvider).theme;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(BodyStyle, { customTheme: theme }),
        children));
}
exports.ThemeGlobalStyles = ThemeGlobalStyles;
var BodyStyle = (0, styled_components_1.createGlobalStyle)(function (_a) {
    var customTheme = _a.customTheme;
    return {
        body: {
            backgroundColor: customTheme.base.background,
        },
    };
});
var BodyVariables = (0, styled_components_1.createGlobalStyle)(function (_a) {
    var customTheme = _a.customTheme;
    var variables = (0, css_variables_1.toCSSVariables)(customTheme);
    return {
        body: (0, tslib_1.__assign)({}, variables),
    };
});
//# sourceMappingURL=theme.js.map